// extracted by mini-css-extract-plugin
module.exports = {"slide":"index_slide_1hwnL","slide-reverse":"index_slide-reverse_1LATc","table":"index_table_2a94V"};